import type { Tab } from "types/tabs.types"

import { ALL_ALERTS_SEARCH_PARAMS } from "./constants"

export const getGroupTabsConfig = (): Tab[] => [
  {
    labelKey: "tabs.OVERVIEW",
    value: 0,
    to: { pathname: "" },
  },
  {
    labelKey: "tabs.ALERTS",
    value: 1,
    to: { pathname: "alerts", search: ALL_ALERTS_SEARCH_PARAMS },
  },
]
